
(() => {
  // ---------- tiny utils ----------
  function $$(root, sel){ return root.querySelector(sel); }
  function $$$(root, sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function norm(s){ return String(s||'').trim().toLowerCase().replace(/\s+/g,' ').replace(/[ _\-]+/g,'-'); }
  function sameSize(a,b){ return norm(a) === norm(b); }
  function uid(){ return 'qb' + Math.random().toString(36).slice(2,9); }
  function cssEscapeId(id){
    if (!id) return id;
    if (window.CSS && CSS.escape) return CSS.escape(id);
    return String(id).replace(/[^a-zA-Z0-9_\-]/g, function(ch){ return '\\' + ch; });
  }

  // ---------- option-order helpers (size may be option1 OR option2, in any order) ----------
  // product.options may be an array of strings OR of {name,values} objects depending on the
  // Shopify version; variant.option1/2/3 and variant.options[] exist regardless of that shape.
  function optName(o){ return (typeof o === 'string') ? o : (o && o.name) || ''; }
  function sizeIndex(product){
    var opts = (product && product.options) || [];
    for (var i=0;i<opts.length;i++){ if (/size/i.test(optName(opts[i]))) return i; }
    // 2-option fallback: whichever option is NOT colour is the size option
    if (opts.length === 2){
      for (var j=0;j<2;j++){ if (/colou?r|couleur|colore/i.test(optName(opts[j]))) return 1 - j; }
    }
    return 0;
  }
  // Name of the size radio group / theme option-position, e.g. "<form>-option2"
  function sizeRadioName(form, product){ return (form && form.id ? form.id : '') + '-option' + (sizeIndex(product) + 1); }
  function variantSizeVal(product, variant){
    if (!variant) return '';
    var i = sizeIndex(product);
    if (variant.options && variant.options.length > i) return variant.options[i];
    return variant['option' + (i + 1)] || variant.title || '';
  }

  // ---------- size ordering ----------
  var RANK = new Map([
    ['xxs',0], ['xs/s',0], ['extra-extra-small',0],
    ['xs',1], ['extra-small',1],
    ['s',2], ['small',2], ['s/m',2],
    ['m',3], ['medium',3], ['m/l',3],
    ['l',4], ['large',4], ['l/xl',4],
    ['xl',5], ['extra-large',5],
    ['xxl',6], ['1x',6], ['2xl',6], ['extra-extra-large',6], ['2x',6],
    ['xxxl',7], ['3xl',7], ['3x',7],
    ['one-size',50], ['os',50]
  ]);
  var CUPS = ['aa','a','b','c','d','dd','e','f','ff','g','gg','h','hh','i','j','k'];
  function cup(raw){
    var c = String(raw||'').toLowerCase().replace(/[\s\-\/]+/g,'');
    if (c === 'ddd' || c === 'eee') c = 'f';
    if (c === 'eeee') c = 'ff';
    return c;
  }
  function parseBra(s){
    var m = String(s||'').trim().match(/^(\d{2,3})\s*[-\s]*([A-Za-z]{1,4})$/);
    return m ? { isBra:true, band:Number(m[1]), cup:cup(m[2]) }
             : { isBra:false, band:Infinity, cup:'zzz' };
  }
  function isBraish(vals){
    if (!vals || !vals.length) return false;
    var cnt = vals.filter(function(v){ return parseBra(v).isBra; }).length;
    return cnt >= Math.ceil(vals.length * 0.6);
  }
  function productSizeOrder(product){
    var opts = (product && product.options) || [];
    var opt = opts[sizeIndex(product)];
    var map = new Map();
    if (opt && Array.isArray(opt.values)){
      for (var j=0;j<opt.values.length;j++){
        map.set(norm(opt.values[j]), j);
      }
    } else {
      // strings shape (no per-option values): derive first-seen order from variants
      var variants = (product && product.variants) || [];
      var idx = 0;
      for (var k=0;k<variants.length;k++){
        var key = norm(variantSizeVal(product, variants[k]));
        if (!map.has(key)) map.set(key, idx++);
      }
    }
    return map;
  }
  var DISPLAY_SIZE = {
    'extra-extra-small': 'XXS',
    'xxs': 'XXS',
    'extra-small': 'XS',
    'xs': 'XS',
    'small': 'S',
    's': 'S',
    'medium': 'M',
    'm': 'M',
    'large': 'L',
    'l': 'L',
    'extra-large': 'XL',
    'xl': 'XL',
    'extra-extra-large': 'XXL',
    'xxl': 'XXL',
    '1x': 'XXL',
    '2xl': '2XL',
    '2x': '2XL',
    '3xl': '3XL',
    '3x': '3XL',
    'xs/s': 'XS/S',
    's/m': 'S/M',
    'm/l': 'M/L',
    'l/xl': 'L/XL',
    'one-size': 'OS',
    'os': 'OS'
  };

  function displaySize(txt){
    var key = norm(txt);
    return DISPLAY_SIZE[key] || txt;
  }
  function sortSizes(names, product){
    var vals = names.map(String);
    if (isBraish(vals)){
      return vals.sort(function(a,b){
        var A = parseBra(a), B = parseBra(b);
        if (A.band !== B.band) return A.band - B.band;
        var ia = CUPS.indexOf(A.cup), ib = CUPS.indexOf(B.cup);
        if (ia !== -1 && ib !== -1 && ia !== ib) return ia - ib;
        return String(a).localeCompare(String(b), undefined, { numeric:true, sensitivity:'base' });
      });
    }
    var pm = productSizeOrder(product);
    return vals.sort(function(a,b){
      var na = norm(a), nb = norm(b);
      var ra = RANK.get(na), rb = RANK.get(nb);
      // Both ranked: sort by rank
      if (ra != null && rb != null) { if (ra !== rb) return ra - rb; }
      // One ranked, one not: ranked always wins (avoids inconsistent mixed comparisons)
      else if (ra != null) { return -1; }
      else if (rb != null) { return 1; }
      // Neither ranked: preserve Shopify admin order
      var A = pm.get(na), B = pm.get(nb);
      if (A != null && B != null && A !== B) return A - B;
      if (A != null && B == null) return -1;
      if (A == null && B != null) return 1;
      return String(a).localeCompare(String(b), undefined, { numeric:true, sensitivity:'base' });
    });
  }

  // ---------- price / currency ----------
  var __pat, __fmt0, __fmt2;
  function formatCents(c, trim){
    if (trim === void 0) trim = true;
    if (!__pat){
      __pat = (function(){
        var n = document.querySelector('sale-price');
        if (!n) return { pre:'', suf:'', dec:'.' };
        var x = n.cloneNode(true);
        Array.prototype.forEach.call(x.querySelectorAll('.sr-only,.visually-hidden'), function(e){ e.parentNode && e.parentNode.removeChild(e); });
        var t = (x.textContent || '').trim();
        var m = t.match(/^(.*?)([\d.,\u00A0\u202F\s]+)(.*?)$/) || [, '', '', ''];
        var decm = m[2].match(/([.,])\d{1,3}\s*$/) || [];
        var dec = decm[1] || '.';
        return { pre:m[1], suf:m[3], dec:dec };
      })();
      var loc = __pat.dec===',' ? 'de-DE' : 'en-US';
      __fmt0 = new Intl.NumberFormat(loc, { minimumFractionDigits:0, maximumFractionDigits:0 });
      __fmt2 = new Intl.NumberFormat(loc, { minimumFractionDigits:2, maximumFractionDigits:2 });
    }
    var v = Math.abs(c||0)/100, neg = (c||0) < 0;
    var use2 = !(trim && Math.round(v*100)%100===0);
    var num = (use2 ? __fmt2 : __fmt0).format(v);
    return (neg?'-':'') + __pat.pre + num + __pat.suf;
  }
  function updatePrice(m, v){
    var wrap = $$(m, '[data-block-type="price"] .price-list');
    if (!wrap) return;
    var onSale = !!(v && v.compare_at_price && v.compare_at_price > v.price);

    // Current price
    var el = wrap.querySelector('sale-price') || wrap.querySelector('.price, .h4, .h6') || wrap;
    if (el){
      el.textContent = v ? formatCents(v.price) : '';
      if (el.classList) el.classList.toggle('text-on-sale', onSale);
    }

    // Struck-through original — shown only when the selected colour is on sale, hidden otherwise.
    // (Sibling colours can mix full-price and sale, so this must toggle per colour.)
    var cap = wrap.querySelector('compare-at-price');
    if (v && onSale){
      if (!cap){
        cap = document.createElement('compare-at-price');
        cap.className = 'text-subdued line-through';
        wrap.appendChild(cap);
      }
      cap.textContent = formatCents(v.compare_at_price);
      cap.style.display = '';
    } else if (cap){
      cap.textContent = '';
      cap.style.display = 'none';
    }
  }
  function updateATC(m, s){
    var available = !!(s && s.available);
    $$$(m, 'button[name="add"], button[type="submit"], [data-add-to-cart]').forEach(function(btn){
      btn.disabled = !available;
      btn.setAttribute('aria-disabled', String(!available));
      btn.classList.toggle('is-disabled', !available);
      if (btn.tagName === 'BUTTON') btn.textContent = available ? 'Add to cart' : 'Sold out';
    });
  }
  function updateHiddenId(m, v){
    var value = (v && v.id) ? String(v.id) : '';
    $$$(m,'form.shopify-product-form input[name="id"], form[action*="/cart/add"] input[name="id"], form.shopify-product-form ~ form input[name="id"]').forEach(function(i){ i.value = value; });
    var terms = $$(m, 'shopify-payment-terms[variant-id]');
    if (terms) terms.setAttribute('variant-id', value);
    $$$(m, 'button[name="add"], button[type="submit"]').forEach(function(btn){
      if (value) btn.dataset.variantId = value; else btn.removeAttribute('data-variant-id');
    });
  }
  function updateLinks(m, handle){
    var href = '/products/' + handle;
    $$$(m, '.quick-buy-modal__view-more, .product-title a, .quick-buy-modal__mobile-info a.product-title').forEach(function(a){
      if (a && a.tagName === 'A') a.setAttribute('href', href);
    });
  }
  function updateTitle(m, p){
    var a = $$(m, '.product-title a, .quick-buy-modal__mobile-info a.product-title');
    if (a && p && p.title) a.textContent = p.title;
  }

  // Repoint the modal's wishlist heart / drop-a-hint / view-link at the shown
  // product (a colour swatch loads a sibling product with a different GID), then
  // re-sync saved state. Scoped to this modal so other controls aren't touched.
  function updateWishlistControls(m, product){
    if (!m || !m.querySelector || !product || product.id == null) return;
    var gid = 'gid://shopify/Product/' + product.id;
    var heart = m.querySelector('[data-jn-wishlist-heart]');
    if (heart){
      heart.setAttribute('data-wl-gid', gid);
      if (product.handle) heart.setAttribute('data-wl-handle', product.handle);
      heart.classList.remove('is-busy');
    }
    var hint = m.querySelector('[data-jn-pdp-hint]');
    if (hint){
      hint.setAttribute('data-wl-gid', gid);
      if (product.handle) hint.setAttribute('data-wl-handle', product.handle);
      if (product.title != null) hint.setAttribute('data-wl-title', product.title);
    }
    var vlink = m.querySelector('[data-jn-wishlist-viewlink]');
    if (vlink) vlink.setAttribute('data-wl-gid', gid);
    if (window.JNWishlist && window.JNWishlist.syncAll) window.JNWishlist.syncAll();
  }
  function buildSrcset(url){
    if (!url) return '';
    var widths = [200,300,400,500,600,700,800,1000];
    var sep = url.indexOf('?') !== -1 ? '&' : '?';
    var out = new Array(widths.length);
    for (var i=0;i<widths.length;i++){ var w = widths[i]; out[i] = url + sep + 'width=' + w + ' ' + w + 'w'; }
    return out.join(', ');
  }
  function updateGallery(m, p, preferredUrl){
    var pg = $$(m,'product-gallery .product-gallery__image-list .product-gallery__carousel-with-arrows scroll-carousel');
    if (!pg) return;
    var images = [];
    if (p && Array.isArray(p.images) && p.images.length){
      for (var i=0;i<p.images.length;i++){
        var it = p.images[i]; images.push(typeof it === 'string' ? it : it.src);
      }
    } else if (preferredUrl) {
      images = [preferredUrl];
    }
    if (!images.length) return;

    var mediaEls = $$$(pg, '.product-gallery__media');
    var count = Math.max(mediaEls.length, Math.min(3, images.length));
    for (var j=0;j<count;j++){
      var url = images[j % images.length];
      var media = mediaEls[j];
      if (!media){
        media = document.createElement('div');
        media.className = 'product-gallery__media snap-center';
        media.dataset.mediaType = 'image';
        media.setAttribute('role','group');
        pg.appendChild(media);
      }
      var img = media.querySelector('img');
      if (!img){ img = document.createElement('img'); media.innerHTML=''; media.appendChild(img); }
      img.src = url;
      img.srcset = buildSrcset(url);
      img.sizes = img.sizes || '(max-width: 699px) calc(100vw - 40px), (max-width: 999px) calc(100vw - 64px), min(1100px, 819px - 96px)';
      img.alt = (p && p.title) || img.alt || '';
      img.loading = j === 0 ? 'eager' : 'lazy';
      if (j === 0){ var preload = new Image(); preload.src = url; }
    }
  }

  // ---------- modal-scoped selectors ----------
  function getSizeBtn(m){ return $$(m, 'fieldset.variant-picker__option button.select'); }
  function getSizeList(m){ return $$(m, 'fieldset.variant-picker__option x-popover .popover__value-list'); }
  function getSizeBlocks(m){ return $$(m, 'fieldset.type-block div.variant-picker__option-values'); }
  function getSizeFS(m){
    var opts = $$$(m, 'fieldset.variant-picker__option');
    for (var i = 0; i < opts.length; i++){
      var leg = $$(opts[i], 'legend');
      if (leg && /size/i.test((leg.textContent||'').trim())) return opts[i];
    }
    return null;
  }
  function getSizeText(m){
    var btn = getSizeBtn(m);
    if (!btn) return null;

    // Prefer canonical value if we set it
    if (btn.dataset && btn.dataset.canonicalSize) {
      return btn.dataset.canonicalSize;
    }

    var span = btn && (btn.querySelector('span[id$="-selected-value"], span'));
    var t = (span && span.textContent || '').trim();
    return t || null;
  }
  function setSizeText(m, txt){
    var btn = getSizeBtn(m);
    var span = btn && (btn.querySelector('span[id$="-selected-value"], span'));
    if (btn && btn.dataset) btn.dataset.canonicalSize = txt || '';
    if (span) span.textContent = txt ? displaySize(txt) : '';
  }
  function getHandleFromModal(m){
    var checked = $$$(m, 'input.js-sibling-swatch:checked')[0];
    if (checked && checked.dataset && checked.dataset.handle) return checked.dataset.handle;
    var link = $$(m, '.product-title a, .quick-buy-modal__view-more');
    var href = (link && link.getAttribute('href')) || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }
  function deriveHandleFromSwatchInput(m, input){
    if (input && input.dataset && input.dataset.handle) return input.dataset.handle;
    function tryExtract(val){
      if (!val) return null;
      var match = String(val).match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    }
    var ks = ['url','href','productUrl','productHref'];
    for (var i=0;i<ks.length;i++){
      var h = tryExtract(input && input.dataset && input.dataset[ks[i]]);
      if (h) return h;
    }
    var lbl = m.querySelector('label[for="'+ cssEscapeId(input && input.id) +'"]');
    if (lbl){
      for (var j=0;j<ks.length;j++){
        var h2 = tryExtract(lbl.dataset && lbl.dataset[ks[j]]);
        if (h2) return h2;
      }
      var a = lbl.querySelector('a[href*="/products/"]');
      var href = a && a.getAttribute && a.getAttribute('href');
      var h3 = tryExtract(href);
      if (h3) return h3;
    }
    var near = input && input.closest && input.closest('label,li,div');
    var link = near && near.querySelector && near.querySelector('a[href*="/products/"]');
    var href2 = link && link.getAttribute && link.getAttribute('href');
    return tryExtract(href2);
  }

  // ---------- PDP duplicate-id killer ----------
  function ensureUniqueIds(modal){
    var form = $$(modal, 'form.shopify-product-form');
    if (form){
      var base = form.id || ('qb-form-' + uid());
      form.id = base + '--' + uid(); // always make modal-unique
    }
    var swatchInputs = $$$(modal, 'input.js-sibling-swatch, fieldset.variant-picker__option input[type="radio"]');
    for (var i=0;i<swatchInputs.length;i++){
      var inp = swatchInputs[i];
      var looksLikeColor = (inp.classList && inp.classList.contains('js-sibling-swatch')) ||
                           (inp.dataset && (inp.dataset.handle || inp.dataset.color || inp.dataset.url));
      if (!looksLikeColor) continue; // don't touch size radios built later
      var old = inp.id;
      var clash = old && document.getElementById(old) && document.getElementById(old) !== inp;
      if (!old || clash) inp.id = (form ? form.id : 'qb') + '--swatch--' + uid();
      var lbl = modal.querySelector('label[for="'+ cssEscapeId(old) +'"]') || inp.closest('label');
      if (lbl){
        if (lbl.getAttribute('for')) lbl.setAttribute('for', inp.id);
        else if (!lbl.contains(inp)) { try { lbl.appendChild(inp); } catch(_){} }
      }
    }
  }

  // ---------- bra picker (band × cup) ----------
  function buildBraPicker(m, form, product, keepTxt) {
    var variants = (product && Array.isArray(product.variants)) ? product.variants : [];
    var bandVariants = new Map();
    var cupDisplay   = new Map();

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i]; if (!v) continue;
      var raw = String(variantSizeVal(product, v)).trim(); if (!raw) continue;
      var p   = parseBra(raw); if (!p.isBra) continue;
      if (!bandVariants.has(p.band)) bandVariants.set(p.band, new Map());
      bandVariants.get(p.band).set(p.cup, v);
      if (!cupDisplay.has(p.cup))
        cupDisplay.set(p.cup, raw.replace(/^\d{2,3}\s*[-\s]*/, '').trim().toUpperCase());
    }

    var allBands = []; bandVariants.forEach(function(_, b){ allBands.push(b); });
    allBands.sort(function(a,b){ return a - b; });
    var allCups = []; cupDisplay.forEach(function(_, c){ allCups.push(c); });
    allCups.sort(function(a,b){
      var ia = CUPS.indexOf(a), ib = CUPS.indexOf(b);
      return ia !== -1 && ib !== -1 ? ia - ib : 0;
    });
    if (!allBands.length || !allCups.length) return;

    // Initial selection from keepTxt
    var selBand = null, selCup = null;
    if (keepTxt) {
      var kp = parseBra(String(keepTxt).trim());
      if (kp.isBra) {
        selBand = kp.band; selCup = kp.cup;
        // DD and E are the same physical cup in different naming systems (US DD = EU E).
        // If the exact cup isn't available for this band, try the alias.
        var _bd = bandVariants.get(selBand);
        if (_bd && !_bd.has(selCup)) {
          var _alias = selCup === 'dd' ? 'e' : (selCup === 'e' ? 'dd' : null);
          if (_alias && _bd.has(_alias)) selCup = _alias;
        }
      }
    }
    if (selBand == null) selBand = allBands[0];
    if (selCup == null) {
      for (var j = 0; j < allCups.length; j++) {
        var cm = bandVariants.get(selBand);
        if (cm && cm.get(allCups[j]) && cm.get(allCups[j]).available) { selCup = allCups[j]; break; }
      }
      if (selCup == null) {
        for (var j2 = 0; j2 < allCups.length; j2++) {
          if (bandVariants.get(selBand) && bandVariants.get(selBand).has(allCups[j2])) { selCup = allCups[j2]; break; }
        }
      }
      if (selCup == null) selCup = allCups[0];
    }

    var sizeFS = getSizeFS(m);
    if (!sizeFS) return;

    var braContainer = $$(sizeFS, '.jn-bra-picker');
    if (!braContainer) {
      braContainer = document.createElement('div');
      braContainer.className = 'jn-bra-picker';
      // Hide existing size UI
      var blocksEl = getSizeBlocks(m);
      if (blocksEl) { blocksEl.style.display = 'none'; blocksEl.setAttribute('data-jn-hidden','1'); }
      var btnEl = getSizeBtn(m);
      if (btnEl) {
        var relWrap = btnEl.closest('.relative') || btnEl;
        relWrap.style.display = 'none'; relWrap.setAttribute('data-jn-hidden','1');
      }
      var optInfo = $$(sizeFS, '.variant-picker__option-info');
      if (optInfo) optInfo.insertAdjacentElement('afterend', braContainer);
      else sizeFS.appendChild(braContainer);
      if (!document.getElementById('jn-bra-style')) {
        var s = document.createElement('style'); s.id = 'jn-bra-style';
        s.textContent = '.jn-bra-picker{display:flex;flex-direction:column;gap:12px;margin-top:4px}.jn-bra-row{display:flex;flex-direction:column;gap:6px}.jn-bra-row__label{font-size:11px;letter-spacing:.06em;text-transform:uppercase;opacity:.6}.jn-bra-row__options{display:flex;flex-wrap:wrap;gap:6px}.block-swatch.jn-unavailable{opacity:.2;pointer-events:none}.jn-bra-picker .block-swatch.is-disabled{pointer-events:auto!important;cursor:pointer}';
        document.head.appendChild(s);
      }
    } else {
      braContainer.innerHTML = '';
    }

    var idPfx = 'jn-bra-' + (form ? form.id : uid());

    var bandRow = document.createElement('div'); bandRow.className = 'jn-bra-row';
    var bandLbl = document.createElement('div'); bandLbl.className = 'jn-bra-row__label'; bandLbl.textContent = 'Band';
    var bandOpts = document.createElement('div'); bandOpts.className = 'jn-bra-row__options';

    allBands.forEach(function(band) {
      var id = idPfx + '-band-' + band;
      var inp = document.createElement('input');
      inp.type = 'radio'; inp.className = 'sr-only'; inp.id = id; inp.name = idPfx + '-band'; inp.value = String(band);
      var lbl = document.createElement('label');
      lbl.className = 'block-swatch'; lbl.setAttribute('for', id);
      lbl.setAttribute('data-band', String(band)); lbl.textContent = String(band);
      inp.addEventListener('change', function() {
        var cupMap = bandVariants.get(band);
        var tc = selCup;
        if (!cupMap || !cupMap.has(tc)) {
          var found = null;
          allCups.forEach(function(c){ if (!found && cupMap && cupMap.get(c) && cupMap.get(c).available) found = c; });
          if (!found) allCups.forEach(function(c){ if (!found && cupMap && cupMap.has(c)) found = c; });
          if (found) tc = found;
        }
        doUpdate(band, tc);
      });
      bandOpts.appendChild(inp); bandOpts.appendChild(lbl);
    });
    bandRow.appendChild(bandLbl); bandRow.appendChild(bandOpts);

    var cupRow = document.createElement('div'); cupRow.className = 'jn-bra-row';
    var cupLbl = document.createElement('div'); cupLbl.className = 'jn-bra-row__label'; cupLbl.textContent = 'Cup';
    var cupOpts = document.createElement('div'); cupOpts.className = 'jn-bra-row__options';

    allCups.forEach(function(cupNorm) {
      var displayName = cupDisplay.get(cupNorm) || cupNorm.toUpperCase();
      var id = idPfx + '-cup-' + cupNorm;
      var inp = document.createElement('input');
      inp.type = 'radio'; inp.className = 'sr-only'; inp.id = id; inp.name = idPfx + '-cup'; inp.value = cupNorm;
      var lbl = document.createElement('label');
      lbl.className = 'block-swatch'; lbl.setAttribute('for', id);
      lbl.setAttribute('data-cup', cupNorm); lbl.textContent = displayName;
      inp.addEventListener('change', function(){ doUpdate(selBand, cupNorm); });
      cupOpts.appendChild(inp); cupOpts.appendChild(lbl);
    });
    cupRow.appendChild(cupLbl); cupRow.appendChild(cupOpts);

    braContainer.appendChild(bandRow);
    braContainer.appendChild(cupRow);

    function doUpdate(band, cup) {
      selBand = band; selCup = cup;
      var bandLbls = bandOpts.querySelectorAll('label');
      for (var i = 0; i < bandLbls.length; i++) {
        var bl = bandLbls[i], b = Number(bl.getAttribute('data-band'));
        var inpEl = document.getElementById(idPfx + '-band-' + b);
        var cupMapB = bandVariants.get(b);
        var anyAvailB = false;
        if (cupMapB) cupMapB.forEach(function(v){ if (v.available) anyAvailB = true; });
        bl.className = anyAvailB ? 'block-swatch' : 'block-swatch is-disabled';
        bl.removeAttribute('aria-disabled');
        if (inpEl) inpEl.checked = (b === band);
      }
      var cupLbls = cupOpts.querySelectorAll('label');
      for (var j = 0; j < cupLbls.length; j++) {
        var cl = cupLbls[j], c = cl.getAttribute('data-cup');
        var inpEl2 = document.getElementById(idPfx + '-cup-' + c);
        var cm2 = bandVariants.get(band);
        var vv2 = cm2 && cm2.get(c);
        cl.className = !vv2 ? 'block-swatch jn-unavailable' : !vv2.available ? 'block-swatch is-disabled' : 'block-swatch';
        if (!vv2) cl.setAttribute('aria-disabled','true'); else cl.removeAttribute('aria-disabled');
        if (inpEl2) inpEl2.checked = (c === cup);
      }
      var cm3 = bandVariants.get(band);
      var variant = cm3 && cm3.get(cup);
      setSizeText(m, variant ? variantSizeVal(product, variant) : '');
      if (variant && variant.available) {
        updateHiddenId(m, variant); updatePrice(m, variant); updateATC(m, variant);
      } else {
        updateHiddenId(m, null); updatePrice(m, null); updateATC(m, { available: false });
      }
    }

    doUpdate(selBand, selCup);
    if (sizeFS) sizeFS.classList.remove('jn-bra-loading');
  }

  // ---------- sizes (rebuild) ----------
  function rebuildSizes(m, product, keepVariantOrText){
    var form = $$(m, 'form.shopify-product-form');
    var list = getSizeList(m);
    var sizeBlocks = getSizeBlocks(m);
    if (!form) return;

    var variants = (product && Array.isArray(product.variants)) ? product.variants : [];
    var all = [];
    for (var i=0;i<variants.length;i++){ var v = variants[i]; var sv = variantSizeVal(product, v); if (sv) all.push(sv); }
    var seen = new Set(), distinct = [];
    for (var j=0;j<all.length;j++){ var s = all[j]; var key = norm(s); if (!seen.has(key)){ seen.add(key); distinct.push(s); } }
    var sorted = sortSizes(distinct, product);

    // Pre-group variants by normalized size to avoid O(n^2) filters
    var bySize = new Map();
    for (var k=0;k<variants.length;k++){
      var vv = variants[k]; var vvs = variantSizeVal(product, vv); if (!vvs) continue;
      var key2 = norm(vvs);
      if (!bySize.has(key2)) bySize.set(key2, []);
      bySize.get(key2).push(vv);
    }

    var keepTxt = (typeof keepVariantOrText === 'string')
      ? keepVariantOrText
      : ((keepVariantOrText && variantSizeVal(product, keepVariantOrText)) || getSizeText(m) || '');

    // Bra picker
    if (window.__jnBraPicker !== false && isBraish(sorted)) {
      buildBraPicker(m, form, product, keepTxt);
      return;
    }
    // Clean up bra picker if switching to a non-bra product
    var _sizeFS = getSizeFS(m);
    var _existingBra = _sizeFS && $$(m, '.jn-bra-picker');
    if (_existingBra) {
      _existingBra.remove();
      $$$(m, '[data-jn-hidden="1"]').forEach(function(el){ el.style.display = ''; el.removeAttribute('data-jn-hidden'); });
    }

    if (list) {

      var radioName = sizeRadioName(form, product);
      list.innerHTML = '';

      var frag = document.createDocumentFragment();

      for (var x=0;x<sorted.length;x++){
        var sizeText = sorted[x];
        var bucket = bySize.get(norm(sizeText)) || [];
        var anyAvailable = false;
        for (var y=0;y<bucket.length;y++){ if (bucket[y].available){ anyAvailable = true; break; } }
        var selected = !!(keepTxt && sameSize(keepTxt, sizeText));
        var id = radioName + '-' + norm(sizeText) + '--' + uid();

        var label = document.createElement('label');
        label.className = 'popover__value-option h-stack justify-between gap-2';
        label.setAttribute('for', id);

        var input = document.createElement('input');
        input.className = 'sr-only';
        input.type = 'radio';
        input.id = id;
        input.name = radioName;
        input.dataset.optionPosition = String(sizeIndex(product) + 1);
        input.value = sizeText;
        input.setAttribute('form', form.id);
        if (selected) input.checked = true;

        var span = document.createElement('span');
        span.textContent = displaySize(sizeText);  

        label.appendChild(input);
        label.appendChild(span);

        if (!anyAvailable){
          var sold = document.createElement('span');
          sold.textContent = 'Sold out';
          label.appendChild(sold);
        }

        frag.appendChild(label);
      }
      list.appendChild(frag);

      var kept = null;
      if (keepTxt){
        for (var z=0;z<sorted.length;z++){ if (sameSize(sorted[z], keepTxt)){ kept = sorted[z]; break; } }
      }
      setSizeText(m, kept || sorted[0] || '');
    } else if(sizeBlocks){

      var radioName = sizeRadioName(form, product);
      sizeBlocks.innerHTML = '';

      var frag = document.createDocumentFragment();

      for (var x = 0; x < sorted.length; x++) {
        var sizeText = sorted[x];
        var bucket = bySize.get(norm(sizeText)) || [];
        var anyAvailable = false;
        for (var y = 0; y < bucket.length; y++) {
          if (bucket[y].available) { anyAvailable = true; break; }
        }
        var selected = !!(keepTxt && sameSize(keepTxt, sizeText));
        var id = radioName + '-' + norm(sizeText) + '--' + uid();

        var input = document.createElement('input');
        input.className = 'sr-only';
        input.type = 'radio';
        input.id = id;
        input.name = radioName;
        input.dataset.optionPosition = String(sizeIndex(product) + 1);
        input.value = sizeText;
        input.setAttribute('form', form.id);
        if (selected) input.checked = true;

        var label = document.createElement('label');
        label.className = 'block-swatch';
        label.setAttribute('for', id);

        var span = document.createElement('span');
        span.textContent = displaySize(sizeText); 
        label.appendChild(span);

        if (!anyAvailable){
          label.className = 'block-swatch is-disabled';
          label.setAttribute('aria-disabled', 'true');
        }

        // 👇 siblings: input then label
        frag.appendChild(input);
        frag.appendChild(label);
      }

      sizeBlocks.appendChild(frag);

    }
  }

  function updateForVariant(m, product, variant, preferredImg){
    updateLinks(m, product.handle);
    updateTitle(m, product);
    updateWishlistControls(m, product);
    updateGallery(m, product, preferredImg);
    if (variant && variant.available){
      updateHiddenId(m, variant);
      updatePrice(m, variant);
      updateATC(m, variant);
    } else {
      updateHiddenId(m, null);
      updatePrice(m, null);
      updateATC(m, { available:false });
    }
  }

  // ---------- shield helpers (kill backdrop/lightbox handlers) ----------
  function shieldEvents(container){
    var typesBlockDefault = ['pointerdown','touchstart','mousedown'];
    var typesStopOnly     = ['pointerup','touchend','mouseup','click'];

    function blockDefault(e){
      if (!container.contains(e.target)) return;
      if (e.cancelable) e.preventDefault();
      e.stopPropagation();
    }
    function stopOnly(e){
      if (!container.contains(e.target)) return;
      e.stopPropagation();
    }

    for (var i=0;i<typesBlockDefault.length;i++){
      container.addEventListener(typesBlockDefault[i], blockDefault, true);
    }
    for (var j=0;j<typesStopOnly.length;j++){
      container.addEventListener(typesStopOnly[j],   stopOnly,   true);
    }
    return { blockDefault:blockDefault, stopOnly:stopOnly };
  }

  // ---------- size interactions ----------
  function attachSizeChange(m, state){
    var list = getSizeList(m);
    var blocks = getSizeBlocks(m);
    if (!list && !blocks) return;


    function applySize(input){
      var sizeText = input.value;
      var variants = (state.product && Array.isArray(state.product.variants)) ? state.product.variants : [];
      var variant = null, i, v;

      for (i = 0; i < variants.length; i++){
        v = variants[i];
        if (sameSize(variantSizeVal(state.product, v), sizeText)){ variant = v; break; }
      }
      if (!variant){
        for (i = 0; i < variants.length; i++){
          v = variants[i];
          if (variantSizeVal(state.product, v) === sizeText){ variant = v; break; }
        }
      }

      // ❗ For blocks, we rely on native .checked from the change event
      // So you can safely delete this line if you want:
      // if (!input.checked) input.checked = true;

      if (list) setSizeText(m, sizeText);

      updateForVariant(
        m,
        state.product || { handle: getHandleFromModal(m) || '' },
        variant,
        null
      );

      if (list) {
        var pop = list.closest && list.closest('x-popover');
        if (pop && typeof pop.hide === 'function') {
          try { pop.hide(); } catch(_){}
        }
      }
    }

    function pickFromEvent(ev){
      var t = ev.target;
      var input = (t instanceof HTMLInputElement) ? t : null;
      if (!input){
        var lab = t && t.closest && t.closest('label.popover__value-option');
        if (lab) input = lab.querySelector('input[type="radio"]');
      }
      if (!(input instanceof HTMLInputElement)) return null;

      var form = $$(m, 'form.shopify-product-form');
      var name = sizeRadioName(form, state.product);
      if (input.name !== name) return null;
      return input;
    }

    function pickFromBlockEvent(ev){
      var t = ev.target;
      var input = (t instanceof HTMLInputElement) ? t : null;
      if (!input){
        var lab = t && t.closest && t.closest('label.block-swatch');
        if (lab) {
          // input is now inside the label
          input = lab.querySelector('input[type="radio"]');
        }
      }
      if (!(input instanceof HTMLInputElement)) return null;

      var form = $$(m, 'form.shopify-product-form');
      var name = sizeRadioName(form, state.product);
      if (input.name !== name) return null;
      return input;
    }

    function onEarly(ev){
      var input = pickFromEvent(ev); if (!input) return;
      if (ev.cancelable) ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      applySize(input);
    }

    function onChange(ev){
      var input = pickFromEvent(ev); if (!input) return;
      applySize(input);
    }

    function onEarlyBlock(ev){
      var input = pickFromBlockEvent(ev); if (!input) return;
      if (ev.cancelable) ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      applySize(input);
    }

    if (list){
      // ✅ keep your existing popover behavior
      list.addEventListener('pointerdown', onEarly,  true);
      list.addEventListener('touchstart',  onEarly,  true);
      list.addEventListener('mousedown',   onEarly,  true);
      list.addEventListener('change',      onChange, true);

      var shield = shieldEvents(list);
      state.handlers.sizeShield    = shield;
      state.handlers.onSizePointer = onEarly;
      state.handlers.onSizeChange  = onChange;

    } else if (blocks){
        function onBlockChange(ev){
        var input = ev.target instanceof HTMLInputElement ? ev.target : null;
        if (!input || input.type !== 'radio') return;

        var form = $$(m, 'form.shopify-product-form');
        var name = sizeRadioName(form, state.product);
        if (input.name !== name) return;

        // Stop the theme’s variant JS from also handling this change
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        else if (ev.stopPropagation) ev.stopPropagation();

        applySize(input);
      }

      // capture ensures we see the change before bubble listeners
      blocks.addEventListener('change', onBlockChange, true);
      state.handlers.onSizeChange = onBlockChange;
    }
  }

  // ---------- swatches (color siblings) ----------
  function attachSwatchChange(m, state){
    function normalizeSwatchInput(root, t){
      var input = (t instanceof HTMLInputElement) ? t : null;
      if (!input){
        var lbl = t && t.closest && t.closest('label');
        if (lbl){
          var forId = lbl.getAttribute('for');
          if (forId){ input = root.querySelector('#'+cssEscapeId(forId)); }
          if (!input) input = lbl.querySelector('input[type="radio"], input.js-sibling-swatch');
        }
        if (!input) input = t && t.closest && t.closest('input[type="radio"], input.js-sibling-swatch');
      }
      return (input instanceof HTMLInputElement) ? input : null;
    }

    var lastHandle = null;

    function onSwatch(ev){
      var input = normalizeSwatchInput(m, ev.target);
      if (!input) return;

      var form = $$(m, 'form.shopify-product-form');
      var sizeName = sizeRadioName(form, state.product);
      if (input.name === sizeName) return; // real size radios handled elsewhere

      var looksLikeSibling =
        (input.classList && input.classList.contains('js-sibling-swatch')) ||
        (input.dataset && input.dataset.handle) ||
        !!deriveHandleFromSwatchInput(m, input);
      if (!looksLikeSibling) return;

      ev.stopPropagation(); if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

      if (!input.checked) input.checked = true;

      // Update "Color: X"
      (function(){
        var fieldset = input.closest && input.closest('fieldset.variant-picker__option');
        var valueSpan = fieldset && (fieldset.querySelector('.variant-picker__option-info .h-stack > span') ||
                                     fieldset.querySelector('.variant-picker__option-info span:last-child'));
        var lbl = m.querySelector('label[for="'+ cssEscapeId(input.id) +'"]');
        var colorText =
          (lbl && lbl.getAttribute('aria-label')) ||
          (lbl && lbl.getAttribute('title')) ||
          (lbl && (lbl.textContent||'').trim()) ||
          (input.dataset && (input.dataset.label || input.dataset.color)) || '';
        if (valueSpan && colorText) valueSpan.textContent = colorText;
      })();

      var handle = (input.dataset && input.dataset.handle) || deriveHandleFromSwatchInput(m, input);
      if (input.dataset) input.dataset.handle = handle;

      function hardOff(){ updateHiddenId(m, null); updateATC(m, { available:false }); }
      if (!handle){ hardOff(); return; }
      if (handle === lastHandle && state.product) return; // no-op if already on this product
      lastHandle = handle;

      if (state.abort && state.abort.abort) state.abort.abort();
      state.abort = (typeof AbortController !== 'undefined')
        ? new AbortController()
        : { abort:function(){}, signal: undefined };

      var keptSize = (function(){
        var checked = sizeName ? m.querySelector('input[type="radio"][name="'+sizeName+'"]:checked') : null;
        if (checked && checked.value) return checked.value.trim();
        return (getSizeText(m) || '').trim();
      })();

      var preferredImg = (input.dataset && input.dataset.image) || '';

      fetch('/products/'+handle+'.js', { signal: state.abort.signal, credentials:'same-origin' })
        .then(function(res){
          if (!res.ok) throw new Error('Fetch failed: '+res.status);
          return res.json();
        })
        .then(function(product){
          state.product = product;
          m.__qb_product__ = product;

          var variants = (product && Array.isArray(product.variants)) ? product.variants : [];
          var exact = null, anyAvail = null, i, v;
          if (keptSize){
            for (i=0;i<variants.length;i++){ v = variants[i]; if (sameSize(variantSizeVal(product, v), keptSize)){ exact = v; break; } }
            if (!exact){
              for (i=0;i<variants.length;i++){ v = variants[i]; if (variantSizeVal(product, v) === keptSize){ exact = v; break; } }
            }
          }
          for (i=0;i<variants.length;i++){ if (variants[i].available){ anyAvail = variants[i]; break; } }

          ensureUniqueIds(m);
          rebuildSizes(m, product, exact || keptSize || (anyAvail && variantSizeVal(product, anyAvail)));

          var forPrice = (exact && exact.available) ? exact : (anyAvail || null);
          updateLinks(m, product.handle);
          updateTitle(m, product);
          updateWishlistControls(m, product);   // colour → sibling product (new GID)
          updateGallery(m, product, preferredImg);
          updatePrice(m, forPrice);

          if (exact && exact.available){
            updateHiddenId(m, exact);
            updateATC(m, exact);
          } else if (exact && !exact.available){
            setSizeText(m, keptSize || 'Select size');
            hardOff();
          } else {
            setSizeText(m, 'Select size');
            hardOff();
          }
        })
        .catch(function(err){
          if (err && err.name === 'AbortError') return;
          try { console.error('[QB] swatch change failed', err); } catch(_){}
          hardOff();
        });
    }

    m.addEventListener('pointerdown', onSwatch, true);
    m.addEventListener('touchstart',  onSwatch, true);
    m.addEventListener('click',       onSwatch, true);
    m.addEventListener('change',      onSwatch, false);

    state.handlers.onSwatchChange = onSwatch;
  }

  // ---------- fetch full product once ----------
  function fetchProductForModal(modal, state){
    var handle = (function(){
      var checked = $$$(modal, 'input.js-sibling-swatch:checked')[0];
      if (checked && checked.dataset && checked.dataset.handle) return checked.dataset.handle;
      var link = $$(modal, '.product-title a, .quick-buy-modal__view-more');
      var href = (link && link.getAttribute('href')) || '';
      var match = href.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    })();
    if (!handle) return Promise.resolve(null);
    return fetch('/products/'+handle+'.js', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ state.product = p || state.product; return state.product; })
      .catch(function(){ return state.product; });
  }

  // ---------- lifecycle ----------
  var STATE = Symbol('qb-state');

  function teardown(m){
    var s = m[STATE];
    if (!s) return;
    try {
      if (s.abort && s.abort.abort) s.abort.abort();
      var list = getSizeList(m);
      if (list){
        if (s.handlers.sizeShield){
          var node = list;
          node.removeEventListener('pointerdown', s.handlers.sizeShield.blockDefault, true);
          node.removeEventListener('touchstart',  s.handlers.sizeShield.blockDefault, true);
          node.removeEventListener('mousedown',   s.handlers.sizeShield.blockDefault, true);
          node.removeEventListener('pointerup',   s.handlers.sizeShield.stopOnly,   true);
          node.removeEventListener('touchend',    s.handlers.sizeShield.stopOnly,   true);
          node.removeEventListener('mouseup',     s.handlers.sizeShield.stopOnly,   true);
          node.removeEventListener('click',       s.handlers.sizeShield.stopOnly,   true);
        }
        if (s.handlers.onSizePointer){
          list.removeEventListener('pointerdown', s.handlers.onSizePointer, true);
          list.removeEventListener('touchstart',  s.handlers.onSizePointer, true);
          list.removeEventListener('mousedown',   s.handlers.onSizePointer, true);
        }
        if (s.handlers.onSizeChange){
          list.removeEventListener('change', s.handlers.onSizeChange, true);
        }
      }
      if (s.handlers.onSwatchChange){
        m.removeEventListener('pointerdown', s.handlers.onSwatchChange, true);
        m.removeEventListener('touchstart',  s.handlers.onSwatchChange, true);
        m.removeEventListener('click',       s.handlers.onSwatchChange, true);
        m.removeEventListener('change',      s.handlers.onSwatchChange, false);
      }
      var closeBtn = $$(m, '.quick-buy-modal__close-button');
      if (closeBtn && s.handlers.onClose) closeBtn.removeEventListener('click', s.handlers.onClose);
      if (s.observer && s.observer.disconnect) s.observer.disconnect();
    } finally { delete m[STATE]; }
  }

  function init(m){
    if (!m) return;
    if (m[STATE]) teardown(m);

    var state = { product:null, abort:null, handlers:{}, observer:null };
    m[STATE] = state;

    ensureUniqueIds(m);

    // seed with inline variant if present
    try {
      var vs = $$(m, 'variant-picker script[type="application/json"][data-variant]');
      if (vs && vs.textContent){
        var v = JSON.parse(vs.textContent);
        state.product = { variants: [v] };
      }
    } catch(_) {}

    attachSwatchChange(m, state);

    fetchProductForModal(m, state).then(function(){
      ensureUniqueIds(m);
      // Ensure size list exists (lazy popover)
      var listNow = getSizeList(m);
      var blocksNow = getSizeBlocks(m);
      if (!listNow && !blocksNow){
        var btn = getSizeBtn(m);
        var opened = false;
        var obs = new MutationObserver(function(){
          if (getSizeList(m)){
            obs.disconnect();
            attachSizeChange(m, state);
            rebuildSizes(m, state.product || { variants: [] }, getSizeText(m));
            if (opened && btn && btn.getAttribute('aria-expanded') === 'true'){
              // leave it open if the user opened it
            }
          }
        });
        obs.observe(m, { childList:true, subtree:true });
        if (btn && btn.getAttribute('aria-expanded') !== 'true'){
          opened = true;
          requestAnimationFrame(function(){ btn.click(); });
        }
      } else {
        attachSizeChange(m, state);
        rebuildSizes(m, state.product || { variants: [] }, getSizeText(m));
      }
    });

    // prevent submit without variant id
    $$$(m, 'form[action*="/cart/add"]').forEach(function(form){
      form.addEventListener('submit', function(e){
        var id = (form.querySelector('input[name="id"]') || {}).value;
        id = (id || '').trim();
        if (!id){ e.preventDefault(); e.stopPropagation(); }
      }, true);
    });

    // teardown when closed/removed
    var closeBtn = $$(m, '.quick-buy-modal__close-button');
    state.handlers.onClose = function(){ teardown(m); };
    if (closeBtn) closeBtn.addEventListener('click', state.handlers.onClose);

    var obs2 = new MutationObserver(function(){
      if (!document.body.contains(m)){ teardown(m); obs2.disconnect(); }
    });
    obs2.observe(document.body, { childList:true, subtree:true });
    state.observer = obs2;
  }

  // auto-init
  var AUTO_KEY = '__qbAutoObserver';
  if (!window[AUTO_KEY]){
    function initIfNeeded(node){
      if (!(node instanceof HTMLElement)) return;
      var targets = node.matches && node.matches('.quick-buy-modal__content')
        ? [node]
        : Array.prototype.slice.call(node.querySelectorAll ? node.querySelectorAll('.quick-buy-modal__content') : []);
      for (var i=0;i<targets.length;i++){
        var m = targets[i];
        if (m.__qb_inited) continue;
        m.__qb_inited = true;
        requestAnimationFrame(function(){ init(m); });
      }
    }
    var mo = new MutationObserver(function(ms){
      for (var i=0;i<ms.length;i++){
        var m = ms[i];
        for (var j=0;j<m.addedNodes.length;j++){
          initIfNeeded(m.addedNodes[j]);
        }
      }
    });
    mo.observe(document.body, { childList:true, subtree:true });
    window[AUTO_KEY] = mo;

    Array.prototype.forEach.call(document.querySelectorAll('.quick-buy-modal__content'), initIfNeeded);

    var qmt = window.queueMicrotask || (window.Promise
      ? function (cb) { Promise.resolve().then(cb); }
      : function (cb) { setTimeout(cb, 0); }
    );
    document.addEventListener('click', function(e){
      var btn = e.target.closest && e.target.closest('.product-card__quick-add-button');
      if (!btn) return;
      qmt(function(){
        var existing = document.querySelector('.quick-buy-modal__content');
        if (existing) initIfNeeded(existing);
      });
    });
  }
})();

